import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function isFallecido(cedula) {
  return API.get(Constants.APIURLS.ISFALLECIDO + cedula);
}

export function isAffiliate(cedula) {
  return API.get(Constants.APIURLS.ISAFILIADO + cedula );
}

export function sendDeceasedAffiliateEmail({
  phoneNumber,
  name,
  lastName,
  email,
  afiliadoId,
  nombreAfiliado = "",
  relationship = "",
  documentId="",
  templateId = "default"
}) {
  return API.post(Constants.APIURLS.ENVIO_EMAIL, {
    phoneNumber,
    name,
    lastName,
    email,
    afiliadoId,
    nombreAfiliado,
    relationship,
    documentId,
    templateId
  });
}